var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.compClass,attrs:{"type":_vm.type,"disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }